interface ISavePolicyModalProps {
  setShowSavePolicyModal: (show: boolean) => void
  savePolicy: () => void
}

function SavePolicyModal(props: ISavePolicyModalProps) {
  const { setShowSavePolicyModal, savePolicy } = props

  const callSavePolicy = async () => {
    savePolicy()
    setShowSavePolicyModal(false)
  }

  return (
    <div
      className="bg-black bg-opacity-50 absolute top-0 left-0 w-full h-full z-50"
      onClick={() => setShowSavePolicyModal(false)}
    >
      <div
        className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-modalBackground rounded-lg p-6 max-h-[50%] overflow-y-auto border dark:border-gray-600 min-w-[400px] min-h-[182px]"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4">Save Policy</h2>
        <p>
          Are you sure you want to update this policy?
          <br />
          This may change compliance rules and affect device access.
          <br />
          Previously blocked devices may become compliant and regain access.
        </p>

        <div className="flex justify-end mt-6">
          <button
            className="px-4 py-2 mr-2 bg-gray-300 rounded-lg text-neutral-12"
            onClick={() => setShowSavePolicyModal(false)}
            type="button"
          >
            Cancel
          </button>
          <button className={`px-4 py-2 bg-mainPurple text-white rounded-lg`} onClick={() => callSavePolicy()}>
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default SavePolicyModal
